import { useEffect, useState } from "react";
import { authFetch } from "@/lib/api";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LOCK_REQUESTS_CHANGED = "veyer:lock-requests-changed";

/** Nombre de demandes de verrouillage en attente (admin uniquement). */
export function usePendingLockRequests(enabled) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) { setCount(0); return undefined; }
    let cancelled = false;
    const refresh = async () => {
      try {
        const res = await authFetch(`${API_BASE}/admin/lock-requests/count`);
        if (res.ok && !cancelled) setCount((await res.json()).pending || 0);
      } catch { /* réseau : on garde la dernière valeur */ }
    };
    refresh();
    const timer = setInterval(refresh, 60000);
    const onFocus = () => { if (document.visibilityState === "visible") refresh(); };
    document.addEventListener("visibilitychange", onFocus);
    window.addEventListener(LOCK_REQUESTS_CHANGED, refresh);
    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onFocus);
      window.removeEventListener(LOCK_REQUESTS_CHANGED, refresh);
    };
  }, [enabled]);

  return count;
}

export function PendingBadge({ count, className = "" }) {
  if (!count) return null;
  return (
    <span
      className={`inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full text-[9.5px] font-bold text-white leading-none ${className}`}
      style={{ background: "#DC2626" }}
      title={`${count} demande${count > 1 ? "s" : ""} de verrouillage en attente`}
      data-testid="lock-requests-badge"
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
